<script setup lang="ts">
  defineOptions({
    name: 'SidebarIcon',
  })

  import { computed, type PropType } from 'vue'

  import { twMerge, type ClassNameValue } from 'tailwind-merge'

  import { sidebarIconHasActiveVariant } from '../utils/sidebar-icon-active-variant-names'

  const props = defineProps({
    iconName: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    class: {
      type: [String, Object, Array] as PropType<ClassNameValue>,
      required: false,
      default: undefined,
    },
  })

  const useStackedActiveCrossfade = computed(() => sidebarIconHasActiveVariant(props.iconName))

  const idleIconName = computed(() => `sidebar-icons:${props.iconName}`)
  const activeIconName = computed(() => `sidebar-icons:${props.iconName}-active`)
  const singleIconName = computed(() => `sidebar-icons:${props.iconName}${props.isActive ? '-active' : ''}`)
</script>

<template>
  <span v-if="useStackedActiveCrossfade" :class="twMerge(['relative inline-flex h-4 w-4 shrink-0', props.class])" v-bind="$attrs">
    <Icon
      :name="idleIconName"
      aria-hidden="true"
      class="pointer-events-none absolute inset-0 size-full transition-opacity duration-200 ease-out motion-reduce:transition-none"
      :class="props.isActive ? 'opacity-0' : 'opacity-100'"
    />
    <Icon
      :name="activeIconName"
      aria-hidden="true"
      class="pointer-events-none absolute inset-0 size-full transition-opacity duration-200 ease-out motion-reduce:transition-none"
      :class="props.isActive ? 'opacity-100' : 'opacity-0'"
    />
  </span>
  <Icon v-else :name="singleIconName" :class="twMerge(['h-4 w-4 flex-shrink-0', props.class])" v-bind="$attrs" />
</template>
